import * as Yup from "yup";

const hexColorSchema = (fieldName: string) => {
  return Yup.string()
    .matches(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/, `${fieldName} must be a valid hex color code`)
    .required(`${fieldName} color is required`);
};

export const validationSchema = Yup.object().shape({
  name: Yup.string().min(1).required("Theme name is required"),
  backgroundColor: hexColorSchema("Background"),
  textColor: hexColorSchema("Text"),
  primaryCtaColor: hexColorSchema("Primary CTA"),
  primaryCtaTextColor: hexColorSchema("Primary CTA Text"),
  showEhLenderLogo: Yup.boolean().optional(),
  showEhOpportunityLogo: Yup.boolean().optional(),
  disclaimer: Yup.string().optional(),
});
